/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedVentureFundRequestDto } from '../../models/backend-patched-venture-fund-request-dto';
import { BackendVentureFundDto } from '../../models/backend-venture-fund-dto';

export interface VentureFundsVentureFundsPartialUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body?: BackendPatchedVentureFundRequestDto;
}

export function ventureFundsVentureFundsPartialUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsVentureFundsPartialUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureFundDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundsPartialUpdate$XWwwFormUrlencoded.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureFundDto>;
    }),
  );
}

ventureFundsVentureFundsPartialUpdate$XWwwFormUrlencoded.PATH = '/api/venture_funds/venture-funds/{id}/';
